<template>
  <div class="viewer">
    <div v-if="firstPageDownloaded">
        <PDFPageV2 v-for="page,i in pages" :page="page" :key="i"></PDFPageV2>
    </div>
    <div v-else>
      rosco...
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import PDFPageV2 from './PDFPageV2.vue'

export default {
  name: 'PDFViewerV2',
  props:{
    url:{
      type:String,
      default:undefined,
    }
  },
  components: {
      PDFPageV2
  },
  data() {
    return {
      
    };
  },
  computed: {
    // ...mapGetters([
    //   // "get_companies",
    //   "get_suppliers",
    //   "get_customers",
    // ]),
    ...mapState("pdf_data",[
      'pages',
      'firstPageDownloaded',
    ]),
    // ...mapGetters("documents", [
    //   "documentUrl",
    //   "documentFetched",
    //   "currentDocument",
    //   "currentDocuments",
    // ]),
  },
  methods: {
    
    // ...mapActions([
    //   "setCompanies",
    //   "setSuppliers",
    //   "setCustomers",
    //   "setCurrentCompany",
    //   "setTags",
    //   "setSupps",
    //   "setCusts",
    // ]),
    ...mapActions({
      setDocumentUrl: "pdf_data/setDocumentUrl",
      cleanDocument: "pdf_data/cleanDocument",
    })
  },
  created() {
    
  },
  mounted(){
    if(this.url)
    {
      this.setDocumentUrl(this.url)
    }
    
  },
  destroyed() {
    console.log("destroying pdf viewer v2")
    this.cleanDocument()
  },
  watch:{
    // url(newUrl,oldUrl){
    //   console.log(`newUrl:${newUrl} oldUrl:${oldUrl}`)
    //   if(newUrl){
    //     this.setDocumentUrl(newUrl)
    //   }else{
    //     this.cleanDocument()
    //   }
      
    // }
  }

}
</script>

<style scoped>
.viewer{
    background-color: #999999;
}
</style>
